/* unplugin-vue-components disabled */import script from "./associationheader.vue?vue&type=script&lang=ts&setup=true"
export * from "./associationheader.vue?vue&type=script&lang=ts&setup=true"

import "./associationheader.vue?vue&type=style&index=0&id=72f5c130&scoped=true&lang=css"

import exportComponent from "D:\\openclawprogram\\sdjk123-vue - Copy (2)\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72f5c130"]])

export default __exports__